export interface BrowserLocaleOptions {
  showLanguageCode?: boolean;
  showCountryCode?: boolean;
}

// Gets the browser locales and filters them by language and/or country code
export function getBrowserLocales(options?: BrowserLocaleOptions): string[] {
  let browserLocales = navigator.languages === undefined ? [navigator.language] : navigator.languages;

  const backupLocales = ['en-US'];
  if (!browserLocales) {
    browserLocales = backupLocales;
  }

  const modifiedLocales = filterLocaleStrings(browserLocales, options);
  if (modifiedLocales.length > 0) {
    return modifiedLocales as string[];
  }
  const backupModifiedLocales = filterLocaleStrings(backupLocales, options) as string[];
  return backupModifiedLocales;
}

export function filterLocaleStrings(locales: readonly string[], options?: BrowserLocaleOptions): (string | null)[] {
  const defaultOptions: BrowserLocaleOptions = {
    showLanguageCode: true,
    showCountryCode: true,
  };

  const opt = options ?? defaultOptions;

  return locales
    .map((locale) => {
      const trimmedLocale = locale.trim();
      const parts = trimmedLocale.split(/-|_/);

      if (parts.length < 2) {
        return null;
      }

      let modifiedLocale = '';
      if (opt.showLanguageCode) {
        // eslint-disable-next-line prefer-destructuring
        modifiedLocale = parts[0];
      }

      if (opt.showCountryCode) {
        const countryCode = parts[1];
        if (modifiedLocale.length === 0) {
          modifiedLocale = countryCode;
        } else {
          modifiedLocale = modifiedLocale.concat('-', countryCode);
        }
      }
      return modifiedLocale.length > 0 ? modifiedLocale : null;
    })
    .filter((x) => !!x);
}
